import TypingTest from './TypingTest';

export default TypingTest;
